<div class="profile-container alt-row-align-center">
  <mat-icon class="cat-img " svgIcon="cat-Banner"></mat-icon>
  <mat-icon (click)="showPanelUser()" class="arrow pointer" svgIcon="arrow" [class.arrow-active]="showMenu === true"></mat-icon>
</div>

<div *ngIf="showMenu == true" class="profileMenu">
    <div class="email alt-justify-center pointer">
      <p class="emial-text alt-inter-medium alt-size-14">{{profileEmail}}</p>
    </div>
    <div class="change-password alt-justify-center pointer">
      <p (click)="resetPswModal()" class="change-psw-text alt-inter-medium alt-size-14">{{"NAV.change-psw" | translate}}</p>
    </div>
    <div class="log-out alt-justify-center pointer">
      <p (click)="logOut()" class="log-out-text alt-inter-semibold alt-size-14 alt-color-system">{{"NAV.log-out" | translate | uppercase}}</p>
    </div>
</div>
